<template>
  <v-dialog
      v-model ="dialog"
      max-width="400"
      persistent
    >
      <v-card flat class="dt-border pad-10">
          <v-btn
            icon
            absolute
            top
            right
            @click="$emit('closeModal')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <br>
        <v-card-title class="d-flex justify-center">
          <p class="text-center text-capitalize">Delete {{detail.title}} Notification</p>
        </v-card-title>
        <v-card-text align="center">
            <v-icon color="error" size="100px" >
                mdi-alert-circle-outline
            </v-icon>
            <br><br>
            <h2>Are you Sure ? </h2>
          <br /><br>
          <default-button :loading="loading" @click="removeNotification()">Yes, Delete !</default-button>
        </v-card-text>
      </v-card>
  </v-dialog>
</template>

<script>
// ================ IMPORT COMPONENTS ================
import DefaultButton from "@/components/Buttons/default-button.vue";

// =========== IMPORT SERVICES ===========
import {AppService} from '@/services';

export default{
    data:() => ({
        loading : false,
        checkbox:false,
    }),
    components: {
        DefaultButton,
    },
    mounted(){
        console.log(this.detail);
    },
    props:{
        detail:{
            type : Object
        },
        dialog:{
            type:Boolean,
            default:false
        },
    },
    methods:{
        async removeNotification(){
            try {
                this.loading = true;
                const data = await AppService.deleteNotification({
                    id : this.detail.id,
                })
                this.loading = false;
                this.$emit('closeModal');
                this.$store.dispatch('toast', {
                    message: data.message,
                    variant: 'success'
                });
                this.$emit('reload')
            } catch (error) {
                this.loading = false
            }
        }
    }
}
</script>